import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Badge } from '../../components/ui/badge';
import { 
  Search, 
  Plus,
  MapPin,
  Globe,
  TrendingUp,
  Edit,
  Eye
} from 'lucide-react';
import { toast } from 'sonner';

const AdminSEOPage = () => {
  const [pages, setPages] = useState([
    { id: '1', title: 'Agence web Paris', city: 'Paris', visits: 1250, position: 3, published: true },
    { id: '2', title: 'Création site Lyon', city: 'Lyon', visits: 890, position: 5, published: true },
    { id: '3', title: 'Développeur Marseille', city: 'Marseille', visits: 654, position: 8, published: true },
    { id: '4', title: 'Webdesign Bordeaux', city: 'Bordeaux', visits: 0, position: null, published: false },
  ]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-[#1a365d]">SEO & Pages villes</h1>
          <p className="text-[#64748b]">Générez des pages optimisées par localité</p>
        </div>
        <Button className="bg-amber-600 hover:bg-amber-700">
          <Plus className="w-4 h-4 mr-2" />
          Nouvelle page ville
        </Button>
      </div>

      {/* Stats */}
      <div className="grid md:grid-cols-3 gap-4">
        <Card>
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
                <Globe className="w-5 h-5 text-blue-600" />
              </div>
              <div>
                <p className="text-2xl font-bold text-[#1a365d]">{pages.filter(p => p.published).length}</p>
                <p className="text-sm text-[#64748b]">Pages publiées</p>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center">
                <TrendingUp className="w-5 h-5 text-emerald-600" />
              </div>
              <div>
                <p className="text-2xl font-bold text-[#1a365d]">{pages.reduce((acc, p) => acc + p.visits, 0)}</p>
                <p className="text-sm text-[#64748b]">Visites totales</p>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-amber-100 flex items-center justify-center">
                <Search className="w-5 h-5 text-amber-600" />
              </div>
              <div>
                <p className="text-2xl font-bold text-[#1a365d]">Top 10</p>
                <p className="text-sm text-[#64748b]">Position moyenne</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Pages List */}
      <Card>
        <CardHeader>
          <CardTitle>Pages générées</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {pages.map((page) => (
              <div key={page.id} className="flex items-center justify-between p-3 rounded-lg border hover:bg-slate-50">
                <div className="flex items-center gap-3">
                  <MapPin className="w-4 h-4 text-amber-600" />
                  <div>
                    <p className="font-medium text-[#1a365d]">{page.title}</p>
                    <p className="text-sm text-[#64748b]">{page.city}</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="text-right">
                    <p className="text-sm font-medium">{page.visits} visites</p>
                    {page.position && (
                      <p className="text-xs text-[#64748b]">Position #{page.position}</p>
                    )}
                  </div>
                  <Badge variant={page.published ? 'default' : 'secondary'}>
                    {page.published ? 'Publié' : 'Brouillon'}
                  </Badge>
                  <Button variant="ghost" size="icon"><Edit className="w-4 h-4" /></Button>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminSEOPage;
